<template>
  <div id="popup-container">
    <v-toolbar dark color="primary">
      <v-toolbar-title class="heading-title"> Import User </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab x-small class="close" @click="closePanel">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-row>
        <v-col class="pa-0 mb-2">
          If you have multiple Users to load in one go then upload them via CSV.
          Download the sample CSV file from here, fill it out and upload it.
          <br/> <br/>
          After importing, please send a welcome email to the user(s) to help them 
          set their new password, or instruct them to reset their password from the login screen.
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-form>
            <v-file-input
              :error-messages="messages.file"
              v-model="user.file"
              placeholder="Upload your CSV"
              label="Upload User’s"
              accept=".csv"
              prepend-icon="mdi-paperclip"
              ref="file"
              v-on:change="handleFileUpload()"
              filled
            >
              <template v-slot:selection="{ text }">
                <v-chip small label color="primary">
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
          </v-form>
        </v-col>
        <v-col>
          <a :href="$globalConfig.APP_NAME == 'senso' ? '/static/Senso-CSV-format.csv' : '/static/IMPROVE-CSV-format.csv'">
            <v-btn color="primary" class="ml-3 add-course-button">
              <v-icon small class="pr-2">fa-download</v-icon> Download sample
              .CSV file
            </v-btn>
          </a>
          <a
            :href="$globalConfig.APP_NAME == 'senso' ? '/static/senso-learn-csv-help-and-support-document-pdf.pdf' : '/static/improve-csv-help-and-support-document-pdf.pdf'"
            download="CSV Help and Support"
          >
            <v-btn color="primary" class="ml-3 add-course-button">
              <v-icon small class="pr-2">fa-download</v-icon> Download CSV Guide
            </v-btn>
          </a>
        </v-col>
      </v-row>
      <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <h4>
            Error Logs
            <v-btn icon class="mr-2">
              <v-icon v-bind="attrs" v-on="on">fa fa-question</v-icon>
            </v-btn>
          </h4>
        </template>
        <span>Any errors in your CSV upload will appear below</span>
      </v-tooltip>
      <template v-for="(item, index) in errors">
        <v-list-tile :key="index" avatar>
          <div style="color: red" class="color-red text-left pt-5">
            <span v-html="item.error"></span>
          </div>
          <div class="" style="display: none">
            <i class="fa fa-times"></i>
          </div>
        </v-list-tile>
      </template>
    </v-container>
    <v-footer height="68">
      <v-flex text-right>
        <v-btn color="grey300" class="mr-4 cancel-button" @click="closePanel"
          >Cancel</v-btn
        >
        <v-btn v-if="loading" color="primary" loading></v-btn>
        <v-btn
          v-else
          color="primary"
          class="add-course-button"
          @click.prevent="confirmBox"
          >Import User</v-btn
        >
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from '@/event-bus.js';
import userAPI from '@/api/user.js';
import companyAPI from '@/api/company.js';
export default {
  name: 'ImportUser',
  data() {
    return {
      file: '',
      errors: [],
      user: {},
      messages: {},
      successMessage: 'User Successfully Added.',
      errorMessage:
        'Oops, something went wrong! Please check information is correct.',
      loading: false,
      confirmText:
        'Are you sure you want to add/update user profile details given in CSV.',
    };
  },
  mounted() {
    this.getErrorLogs();
  },
  methods: {
    closePanel() {
      this.$emit('closePanel', {});
    },
    handleFileUpload() {
      this.file = this.user.file;
    },
    importUser() {
      this.$snotify.remove();
      const backdrop = document.querySelector('.snotify-backdrop');
      if (backdrop) {
        backdrop.parentNode.removeChild(backdrop);
      }
      this.loading = true;
      userAPI
        .importUser(this.file)
        .then((response) => {
          if (response.data.error) {
            this.$snotify.success(response.data.error);
          } else {
            this.$snotify.success(this.successMessage);
            this.closePanel();
          }
          this.getErrorLogs();
          EventBus.$emit('USERS_UPDATED');
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch((err) => {
          this.valid = false;
          this.messages = this.$gf.errorResponse(err);
          let errMsg = err.response.data.message;
          if (errMsg) {
            this.errorMessage = errMsg;
            this.$snotify.error(errMsg);
          } else {
            this.$snotify.error(this.errorMessage);
          }
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    getErrorLogs() {
      companyAPI.getErrorLogs().then((response) => {
        this.errors = response.data.data;
      });
    },
    confirmBox() {
      this.$snotify.confirm(this.confirmText, {
        backdrop: 0.3,
        buttons: [
          { text: 'Cancel', className: 'toast-cancel-button' },
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) => this.importUser(toast),
          },
        ],
      });
    },
  },
};
</script>
<style scoped>
.v-application .ml-3.add-course-button {
  margin-bottom: 5px;
}
</style>
